export default [
  {
    label: 'Deal promotion',
    value: 'DEAL_PROMOTION'
  }
];
